import * as React from 'react';
import { useAppTranslation } from '../../services/i18n';
import { SettingRow, SettingsCard } from './SettingRow';
import { SettingsTabProps } from './settingsTab';

export const ContentSettings = ({ settings, isOwner, onSave }: SettingsTabProps) => {
  const t = useAppTranslation();

  return (
    <SettingsCard title={t('companySettings.content.title')}>
      <SettingRow
        label={t('companySettings.content.userContentCreation.label')}
        helper={t('companySettings.content.userContentCreation.helper')}
        checked={settings.user_content_creation}
        disabled={!isOwner}
        onChange={(value) => onSave({ user_content_creation: value })}
      />
      <SettingRow
        label={t('companySettings.content.userContentActivation.label')}
        helper={t('companySettings.content.userContentActivation.helper')}
        checked={settings.user_content_activation}
        disabled={!isOwner}
        onChange={(value) => onSave({ user_content_activation: value })}
      />
      <SettingRow
        label={t('companySettings.content.autoContentUpgrade.label')}
        helper={t('companySettings.content.autoContentUpgrade.helper')}
        checked={settings.auto_content_upgrade}
        disabled={!isOwner}
        onChange={(value) => onSave({ auto_content_upgrade: value })}
      />
    </SettingsCard>
  );
};
